import $ from 'jquery'
import mousetrap from 'mousetrap'
import mousetrapGlobalBind from 'mousetrap-global-bind'

export default function(footerDiv){

  // mousetrap.bind('mod+shift+right',function(){
  //   if(o.video){
  //     if(o.playing && o.looping){
  //       o.loopStart = o.loopStart + 1 / 24
  //     } else {
  //       if(o.playing){
  //         o.controls.stop.click()
  //       }
  //       o.loopStart = o.video.currentTime + 1 / 24
  //       o.video.currentTime += 1 / 24
  //     }
  //     return false
  //   }
  // })

  // mousetrap.bind('shift+right',function(){
  //   if(o.video){
  //     if(o.playing && o.looping){
  //       o.loopStart = o.loopStart + 1
  //     } else {
  //       if(o.playing){
  //         o.controls.stop.click()
  //       }
  //       o.loopStart = o.video.currentTime + 1
  //       o.video.currentTime += 1
  //     }
  //     return false
  //   }
  // })

  // mousetrap.bind('right',function(){
  //   if(o.video){
  //     if(o.playing && o.looping){
  //       o.loopStart = o.loopStart + 10
  //     } else{
  //       if(o.playing){
  //         o.controls.stop.click()
  //       }
  //       o.loopStart = o.video.currentTime + 10
  //       o.video.currentTime += 10
  //     }
  //     return false
  //   }
  // })

  // mousetrap.bind('mod+shift+left',function(){
  //   if(o.video){
  //     if(o.playing && o.looping){
  //       o.loopStart = o.loopStart - 1 / 24
  //     } else{
  //       if(o.playing){
  //         o.controls.stop.click()
  //       }
  //       o.loopStart = o.video.currentTime - 1 / 24
  //       o.video.currentTime -= 1 / 24
  //     }
  //     return false
  //   }
  // })

  // mousetrap.bind('shift+left',function(){
  //   if(o.video){
  //     if(o.playing && o.looping){
  //       o.loopStart = o.loopStart - 1
  //     } else{
  //       if(o.playing){
  //         o.controls.stop.click()
  //       }
  //       o.loopStart = o.video.currentTime - 1
  //       o.video.currentTime -= 1
  //     }
  //     return false
  //   }
  // })

  // mousetrap.bind('left',function(){
  //   if(o.video){
  //     if(o.playing && o.looping){
  //       o.loopStart = o.loopStart - 10
  //     } else{
  //       if(o.playing){
  //         o.controls.stop.click()
  //       }
  //       o.loopStart = o.video.currentTime - 10
  //       o.video.currentTime -= 10
  //     }
  //     return false
  //   }
  // })

  console.log('setupShortcuts');

  mousetrap.bind('space',footerDiv.togglePlay)

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/views/roll/shortcuts/shortcuts.js